import React, { FC, useEffect } from "react";
import { Country, getCountries, getCountryCallingCode } from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import flags from "react-phone-number-input/flags";
import styles from "./Dropdown.module.css";
import useComponentVisible from "../../../hooks/useComponentVisible";
import { Flag } from "../../../types";

interface DropdownProps {
  toggle: {
    current: boolean;
    set: React.Dispatch<React.SetStateAction<boolean>>;
  };
  onChange: (_flagIcon: Flag, _callingCode: string, _country: string, _ISO: Country) => void;
}

const Dropdown: FC<DropdownProps> = ({ toggle, onChange }) => {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  useEffect(() => {
    setIsComponentVisible(toggle.current);
  }, [toggle.current]);
  useEffect(() => {
    toggle.set(isComponentVisible);
  }, [isComponentVisible]);
  const setCountry = (flagIcon: Flag, callingCode: string, country: string, ISO: Country) => {
    if (!flagIcon) return;
    onChange(flagIcon, callingCode, country, ISO);
  };
  return (
    <div ref={ref} className={`${styles.DropdownWrapper} ${toggle.current ? styles.Expanded : styles.Collapse}`}>
      <div className={styles.Dropdown}>
        {getCountries().map((country) => {
          const flagIcon = flags[country];
          return (
            <div
              role="button"
              tabIndex={0}
              onKeyDown={() => {}}
              className={styles.Row}
              key={country}
              onClick={() => {
                setCountry(flagIcon, getCountryCallingCode(country), en[country], country);
                toggle.set(!toggle.current);
              }}
            >
              <div className={styles.Flag}>{flagIcon ? flagIcon({ title: "South Africa" }) : null}</div>
              <div className={styles.Code}>+{getCountryCallingCode(country)}</div>
              <div className={styles.Divider}>|</div>
              <div className={styles.Value}>{en[country]}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Dropdown;
